// @flow
export { default } from './ProductGuide';



// WEBPACK FOOTER //
// ./src/components/product/ProductGuide/index.js